/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { PaymentPermissionResponse, PermissionUpdateActionRequest } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class PaymentPermissionV2Controller<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags payment-permission-v-2-controller
   * @name UpdatePaymentPermissionType
   * @request PATCH:/api/v2/payment-permissions/update/{id}/permission-type/{permissionType}
   */
  updatePaymentPermissionType = (
    id: string,
    permissionType: 'VIEW' | 'PREPARE' | 'RELEASE',
    data: PermissionUpdateActionRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<PaymentPermissionResponse, any>({
      path: `/v2/payment-permissions/update/${id}/permission-type/${permissionType}`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updatePaymentPermissionTypePath =
    '/v2/payment-permissions/update/${id}/permission-type/${permissionType}'
  static updatePaymentPermissionTypeMethod = 'PATCH'
}
